import React from 'react'
import { FormGroup as ReactstrapFormGroup, FormGroupProps as ReactstrapFormGroupProps } from 'reactstrap'
import styles from '@bt-react/styles'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export interface FormGroupProps extends Partial<ReactstrapFormGroupProps> {
  dataBdd?: string
  className?: string
}

export default class FormGroup extends React.Component<FormGroupProps> {

  static propTypes = {
    children: PropTypes.node.isRequired
  }

  render () {

    // reactstrap 9 renders `mb-3` (1rem) in place of `.form-group`; keep `.form-group` for the BT
    // $form-group-margin-bottom (1.3em) and turn off reactstrap's margin with noMargin
    return <ReactstrapFormGroup
      noMargin
      className={classnames('form-group', this.props.className)}
      cssModule={styles}
      data-bdd={this.props.dataBdd || 'form-group'}
    >{this.props.children}
    </ReactstrapFormGroup>

  }

}
